import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { BrowserUtils } from "@azure/msal-browser";

import { MsalGuard } from "@azure/msal-angular";

const routes: Routes = [
  {
    path: '',
    loadChildren: () =>
      import('./modules/login/login.module').then((m) => m.LoginModule),
  },
  {
    path: 'dashboard',
    loadChildren: () =>
      import('./modules/dashboard/dashboard.module').then((m) => m.DashboardModule),
    canActivate: [MsalGuard],
  },
  {
    path: 'deviceManagement',
    loadChildren: () =>
      import('./modules/device-management/device-management.module').then((m) => m.DeviceManagementModule),
  },
  {
    path: 'packageManagment',
    loadChildren: () =>
      import('./modules/package-management/package-management.module').then((m) => m.PackageManagementModule),
    canActivate: [MsalGuard]
  },
  {
    path: 'devices',
    loadChildren: () =>
      import('./modules/devices/devices.module').then((m) => m.DevicesModule),
    canActivate: [MsalGuard]
  },
  {
    path: 'userManagement',
    loadChildren: () =>
      import('./modules/user-management/user-management.module').then((m) => m.UserManagementModule),
    canActivate: [MsalGuard]
  },
  {
    path: '**',
    loadChildren: () =>
      import('./modules/login/login.module').then((m) => m.LoginModule)
  }
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes,
      {
        initialNavigation:
          !BrowserUtils.isInIframe() && !BrowserUtils.isInPopup()
            ? "enabledNonBlocking"
            : "disabled", // Set to enabledBlocking to use Angular Universal
      }
    ),
  ],
  exports: [RouterModule]
})
export class AppRoutingModule { }
